<template>
  <!-- eslint-disable -->
  <svg
    class="hidden md:block"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1062.28 635.58"
  >
    <g id="Ebene_3">
      <path
        opacity=".4"
        fill="#4181D2"
        d="M747.57 56.11h281v493.13h-281z"
      />
      <path
        opacity=".3"
        fill="#4181D2"
        d="M430.91 56.11h281v493.13h-281z"
      />
      <path
        opacity=".2"
        fill="#4181D2"
        d="M119.57 56.11h281v493.13h-281z"
      />
      <path
        class="st23"
        d="M160.16 426.85h94.11v72.42h-94.11z"
      />
      <text transform="translate(160.157 438.127)">
        <tspan
          x="0"
          y="0"
          class="st1 st24 st25"
        >Klassik-</tspan>
        <tspan
          x="0"
          y="19.2"
          class="st1 st24 st25"
        >Rente</tspan>
        <tspan
          x="0"
          y="38.4"
          class="st1 st26 st25"
        >neu</tspan>
      </text>
      <path
        class="st23"
        d="M234.82 397.68h61.45v72.09h-61.45z"
      />
      <text transform="translate(234.824 408.96)">
        <tspan
          x="0"
          y="0"
          class="st1 st24 st25"
        >Hybrid</tspan>
        <tspan
          x="0"
          y="15.2"
          class="st1 st24 st25"
        >Rente</tspan>
        <tspan
          x="0"
          y="30.4"
          class="st1 st26 st25"
        >alt</tspan>
      </text>
      <path
        class="st23"
        d="M305.66 489.18h80.45v79.09h-80.45z"
      />
      <text transform="translate(305.658 500.46)">
        <tspan
          x="0"
          y="0"
          class="st1 st24 st25"
        >Hybrid</tspan>
        <tspan
          x="0"
          y="15.2"
          class="st1 st24 st25"
        >Rente</tspan>
        <tspan
          x="0"
          y="30.4"
          class="st1 st26 st25"
        >neu</tspan>
      </text>
      <path
        class="st23"
        d="M332.66 358.18h68.45v59.09h-68.45z"
      />
      <text transform="translate(332.658 369.46)">
        <tspan
          x="0"
          y="0"
          class="st1 st26 st25"
        >Index</tspan>
        <tspan
          x="43.01"
          y="0"
          class="st1 st24 st25"
        />
        <tspan
          x="0"
          y="15.2"
          class="st1 st24 st25"
        >Hybrid-</tspan>
        <tspan
          x="0"
          y="30.4"
          class="st1 st24 st25"
        >Rente</tspan>
      </text>
      <path
        class="st23"
        d="M456.66 307.68h121.95v54.09H456.66z"
      />
      <text transform="translate(456.658 318.96)">
        <tspan
          x="0"
          y="0"
          class="st1 st24 st25"
        >Garantie-</tspan>
        <tspan
          x="0"
          y="15.2"
          class="st1 st24 st25"
        >fonds-Rente</tspan>
      </text>
      <path
        class="st23"
        d="M570.16 384.68h113.95v57.59H570.16z"
      />
      <text transform="translate(570.158 395.96)">
        <tspan
          x="0"
          y="0"
          class="st1 st26 st25"
        >Interne</tspan>
        <tspan
          x="55.62"
          y="0"
          class="st1 st24 st25"
        />
        <tspan
          x="0"
          y="15.2"
          class="st1 st24 st25"
        >dynamische</tspan>
        <tspan
          x="0"
          y="30.4"
          class="st1 st24 st25"
        >Hybrid Rente</tspan>
      </text>
      <path
        class="st23"
        d="M603.16 242.18h113.45v79.09H603.16z"
      />
      <text transform="translate(603.158 253.46)">
        <tspan
          x="0"
          y="0"
          class="st1 st26 st25"
        >externe</tspan>
        <tspan
          x="58.99"
          y="0"
          class="st1 st24 st25"
        />
        <tspan
          x="0"
          y="15.2"
          class="st1 st24 st25"
        >dynamische</tspan>
        <tspan
          x="0"
          y="30.4"
          class="st1 st24 st25"
        >Hybrid Rente</tspan>
      </text>
      <path
        class="st23"
        d="M768.16 165.52h72.28v53.92h-72.28z"
      />
      <text transform="translate(768.158 176.794)">
        <tspan
          x="0"
          y="0"
          class="st1 st24 st25"
        >Bank</tspan>
        <tspan
          x="0"
          y="19.2"
          class="st1 st24 st25"
        >Garantie</tspan>
        <tspan
          x="0"
          y="38.4"
          class="st1 st24 st25"
        >Rente</tspan>
      </text>
      <path
        class="st23"
        d="M870.99 255.35h93.45v74.09h-93.45z"
      />
      <text transform="translate(870.991 266.627)">
        <tspan
          x="0"
          y="0"
          class="st1 st24 st25"
        >With</tspan>
        <tspan
          x="0"
          y="19.2"
          class="st1 st24 st25"
        >Profit</tspan>
        <tspan
          x="0"
          y="38.4"
          class="st1 st24 st25"
        >Rente</tspan>
      </text>
      <path
        class="st23"
        d="M923.99 224.02h69.11v37.42h-69.11z"
      />
      <text transform="translate(923.991 235.294)">
        <tspan
          x="0"
          y="0"
          class="st1 st24 st25"
        >Variable</tspan>
        <tspan
          x="0"
          y="19.2"
          class="st1 st24 st25"
        >Annuity</tspan>
      </text>
      <path
        class="st23"
        d="M946.99 109.68h84.78v35.09h-84.78z"
      />
      <text transform="translate(946.99 120.96)">
        <tspan
          x="0"
          y="0"
          class="st1 st24 st25"
        >FRV ohne</tspan>
        <tspan
          x="0"
          y="19.2"
          class="st1 st24 st25"
        >Garantie</tspan>
      </text>
      <path
        fill="#fff"
        stroke="#4181D2"
        stroke-width="5"
        stroke-miterlimit="10"
        d="M 198.53 499.39 L 1018.39 162.32"
      />
      <path
        class="st7"
        d="M118.75 582.24h898.31"
      />
      <path
        class="st8"
        d="M1015.35 569.49V595l12.75-12.76z"
      />
      <path
        class="st7"
        d="M92.43 551.92V68.48"
      />
      <path
        class="st8"
        d="M79.67 70.19h25.51L92.43 57.44z"
      />
      <path
        class="st23"
        d="M118.77 609.57h908.33v18H118.77z"
      />
      <text
        transform="translate(537.394 620.85)"
        class="st24 st25"
      >
        Sicherheit
      </text>
      <path
        class="st23"
        d="M118.1 13.07h279v47.2h-279z"
      />
      <text
        transform="translate(183.13 34.224)"
        class="st8 st26 st27"
      >
        Wachstum
      </text>
      <path
        class="st23"
        d="M429.1 13.07h281v47.2h-281z"
      />
      <text
        transform="translate(516.955 34.224)"
        class="st8 st26 st27"
      >
        Rendite
      </text>
      <path
        class="st23"
        d="M748.1 13.07h280v47.2h-280z"
      />
      <text
        transform="translate(837.465 34.224)"
        class="st8 st26 st27"
      >
        Chance
      </text>
      <path
        d="M59.35 336.84c-.46.79-1.13 1.39-2 1.82-.87.42-1.9.63-3.08.63-1.18 0-2.21-.21-3.07-.63-.86-.42-1.53-1.03-1.99-1.82s-.7-1.72-.7-2.78c0-.78.12-1.49.36-2.14.24-.65.59-1.22 1.06-1.7l1.01.5c-.46.54-.79 1.08-.99 1.6-.2.52-.3 1.1-.3 1.73 0 1.24.4 2.19 1.21 2.87.81.68 1.94 1.02 3.42 1.02s2.63-.34 3.43-1.02c.81-.68 1.21-1.63 1.21-2.87 0-.63-.1-1.21-.3-1.73-.2-.52-.53-1.06-.99-1.6l1.01-.5c.47.48.82 1.05 1.06 1.7.24.65.36 1.37.36 2.14-.01 1.06-.24 1.99-.71 2.78zM55.02 321.51h4.9v1.3H55.1c-.72 0-1.25.14-1.58.42-.33.28-.5.73-.5 1.35 0 .71.22 1.29.66 1.71.44.43 1.03.64 1.78.64h4.46v1.3H48.64v-1.3h4.74c-.47-.26-.83-.61-1.07-1.06-.25-.45-.37-.97-.37-1.56 0-1.87 1.03-2.8 3.08-2.8zM52.7 313.76c.51-.49 1.28-.73 2.31-.73h4.91v1.26h-1.33c.46.2.81.51 1.06.93.25.42.38.9.38 1.44 0 .5-.1.96-.3 1.38-.2.42-.49.75-.85 1s-.76.37-1.2.37c-.59 0-1.04-.15-1.37-.45-.33-.3-.56-.79-.7-1.47-.14-.68-.22-1.63-.22-2.85v-.35h-.53c-.65 0-1.12.13-1.42.4-.29.27-.44.7-.44 1.3 0 .9.28 1.79.83 2.67l-.94.43c-.29-.41-.52-.89-.7-1.46-.18-.57-.26-1.12-.26-1.66.01-.99.26-1.73.77-2.21zm5.66 1.15c-.43-.41-.99-.62-1.67-.62h-.46v.29c0 .94.04 1.65.12 2.14.08.49.21.84.4 1.05s.46.31.82.31c.42 0 .76-.15 1.03-.46.27-.3.41-.69.41-1.14 0-.63-.22-1.16-.65-1.57zM55.02 303.94h4.9v1.3H55.1c-.72 0-1.25.14-1.58.42-.33.28-.5.73-.5 1.35 0 .71.22 1.29.66 1.71s1.03.64 1.78.64h4.46v1.3h-7.79v-1.28h1.28c-.48-.26-.85-.61-1.1-1.07-.25-.46-.38-.98-.38-1.57.01-1.86 1.04-2.8 3.09-2.8zM59.54 300.28c-.33.57-.8 1-1.4 1.3-.6.3-1.31.46-2.12.46s-1.52-.16-2.14-.47-1.09-.76-1.43-1.33c-.34-.57-.51-1.24-.51-2.01 0-.52.09-1.03.28-1.54.19-.5.43-.91.74-1.22l.96.43c-.6.74-.9 1.48-.9 2.24 0 .8.26 1.42.78 1.87.52.45 1.26.67 2.21.67.94 0 1.66-.22 2.18-.67.51-.45.77-1.07.77-1.87 0-.76-.3-1.5-.9-2.24l.96-.43c.31.33.56.75.74 1.25.18.5.27 1.02.27 1.55 0 .78-.16 1.44-.49 2.01zM56.22 287.38v5.7c.91-.04 1.59-.29 2.06-.74.46-.45.7-1.08.7-1.9 0-.91-.31-1.74-.93-2.5l.94-.43c.32.34.57.78.76 1.31s.28 1.08.28 1.63c0 1.22-.36 2.17-1.07 2.87-.71.7-1.7 1.05-2.96 1.05-.8 0-1.51-.15-2.12-.46-.61-.31-1.09-.74-1.43-1.3-.34-.56-.51-1.2-.51-1.91 0-1.03.34-1.85 1.02-2.43.68-.59 1.61-.88 2.79-.88h.47zm-2.64 4.94c.43.41 1.03.65 1.81.73v-4.53c-.79.02-1.39.22-1.82.59-.42.37-.63.9-.63 1.57 0 .68.22 1.23.64 1.64z"
      />
      <path
        class="st23"
        d="M114.77 610.9h185.67v18H114.77z"
      />
      <text
        transform="translate(114.77 622.184)"
        class="st24 st25"
      >
        100%
      </text>
      <path
        class="st23"
        d="M9.77 58.9h185.67v18H9.77z"
      />
      <text
        transform="translate(9.77 70.184)"
        class="st24 st25"
      >
        100%
      </text>
      <path
        class="st23"
        d="M842.77 610.9h185.67v18H842.77z"
      />
      <text
        transform="translate(1003.318 622.184)"
        class="st24 st25"
      >
        0%
      </text>
      <path
        class="st23"
        d="M-125.23 539.9H60.44v18h-185.67z"
      />
      <text
        transform="translate(35.318 551.184)"
        class="st24 st25"
      >
        0%
      </text>
      <path
        class="st9"
        d="M200.67 507.11l-9.13-30.17M258.6 467.77v-22.75M310.85 481.38l-6.98-29.96M356.36 428.28v-24.01M505.86 375.27v-35.5M573.86 373.77v-35.5M612.8 325.01l6.12-34.97M834.3 237.75l-11.88-33.45M1019.3 165.5l-9.45-22.98M943.05 219.75l-9.45-22.98M888.17 242.63l-2.18-24.74"
      />
      <circle
        :class="$style.hoverStyles"
        class="st12"
        cx="198.53"
        cy="499.39"
        r="15.38"
        @click="$emit('handleScrolling',tarifNames[1])"
      />
      <circle
        :class="$style.hoverStyles"
        class="st12"
        cx="260.61"
        cy="474.18"
        r="15.38"
        @click="$emit('handleScrolling', tarifNames[2])"
      />
      <circle
        :class="$style.hoverStyles"
        class="st12"
        cx="304.6"
        cy="456.4"
        r="15.38"
        @click="$emit('handleScrolling', tarifNames[3])"
      />
      <circle
        :class="$style.hoverStyles"
        class="st12"
        cx="356.98"
        cy="436.13"
        r="15.38"
        @click="$emit('handleScrolling', tarifNames[4])"
      />
      <circle
        :class="$style.hoverStyles"
        class="st12"
        cx="507.04"
        cy="373.19"
        r="15.38"
        @click="$emit('handleScrolling', tarifNames[5])"
      />
      <circle
        :class="$style.hoverStyles"
        class="st12"
        cx="573.22"
        cy="344.77"
        r="15.38"
        @click="$emit('handleScrolling', tarifNames[6])"
      />
      <circle
        :class="$style.hoverStyles"
        cx="614.81"
        cy="328.59"
        r="15.38"
        fill="#fff"
        stroke="#4181D2"
        stroke-width="3"
        stroke-miterlimit="10"
        @click="$emit('handleScrolling', tarifNames[7])"
      />
      <circle
        :class="$style.hoverStyles"
        class="st12"
        cx="833.97"
        cy="236.52"
        r="15.38"
        @click="$emit('handleScrolling', tarifNames[8])"
      />
      <circle
        :class="$style.hoverStyles"
        class="st12"
        cx="886.35"
        cy="216.25"
        r="15.38"
        @click="$emit('handleScrolling', tarifNames[9])"
      />
      <circle
        :class="$style.hoverStyles"
        class="st12"
        cx="932.68"
        cy="195.1"
        r="15.38"
        @click="$emit('handleScrolling', tarifNames[10])"
      />
      <circle
        :class="$style.hoverStyles"
        class="st12"
        cx="1018.39"
        cy="162.32"
        r="15.38"
        @click="$emit('handleScrolling', tarifNames[11])"
      />
    </g>
  </svg>
  <!-- eslint-enable -->
</template>

<script>
export default {
  props: {
    tarifNames: {
      type: Object,
      required: true,
    },
  },
  emits: ['handleScrolling'],
};
</script>

<style lang="scss" scoped>
  .st1 {
    fill: #4181D2;
  }

  .st7 {
    fill: none;
    stroke: #333;
    stroke-miterlimit: 10;
    stroke-width: 3;
  }

  .st8 {
    fill: #333;
  }

  .st12,
  .st9 {
    fill: none;
    stroke: #4181D2;
    stroke-miterlimit: 10;
    stroke-width: 3;
  }

  .st12 {
    fill: #fff;
  }

  .st23 {
    fill: none;
  }

  .st25 {
    font-size: 16px;
  }

  .st27 {
    font-size: 30px;
  }
</style>

<style lang="scss" module>

  .hoverStyles {
    cursor: pointer;

    &:hover {
      fill: #B4B8C0;
    }

    &:active {
      fill: #858B98;
    }
  }
</style>
